import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccountSavedCardsComponentDef } from '@df/account/account-saved-cards.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { RadioComponent } from '../../../ui/form/radio';

@Component({
    selector: 'account-saved-cards-details',
    templateUrl: './account-saved-cards-details.component.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, FormsModule, RadioComponent, ResultComponent, SizeClassDirective, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountSavedCardsDetailsComponent extends AccountSavedCardsComponentDef {}
